import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import InfrastructureDashboard from '../components/Server/InfrastructureDashboard';

export default function InfrastructureDashboardPage() {
  const navigate = useNavigate();
  return (
    <Layout noSidebar={true}>
      <InfrastructureDashboard onClose={() => navigate('/tickets')} />
    </Layout>
  );
}
